import { actionTypes } from "redux-query";
import { setConnectionId } from "store/signalR";
const pending = [];
const isAsyncRequest = (action) => action &&
    (action.type === actionTypes.MUTATE_ASYNC || action.type === actionTypes.REQUEST_ASYNC || action.type === actionTypes.REQUEST_START) &&
    action.meta?.isAsync === true;
const runLater = (dispatch, queryKey) => {
    pending.push({ delayedAction: dispatch, done: false, queryKey });
};
const updateAction = (action, connectionId) => {
    const options = action.options || {};
    const headers = options.headers || {};
    if (connectionId) {
        return {
            ...action,
            options: {
                ...options,
                headers: {
                    ...headers,
                    connectionId,
                    "use-async": true
                }
            }
        };
    }
    return action;
};
const getConnectionId = (queryKey, connections) => connections?.find((c) => queryKey?.indexOf(c.requestId) === 0)?.connectionId;
export const websocketMiddleware = (store) => (next) => (action) => {
    if (isAsyncRequest(action)) {
        const state = store.getState();
        const connectionId = getConnectionId(action.queryKey, state?.asyncRequests?.connectionIds);
        if (connectionId) {
            return next(updateAction(action, connectionId));
        }
        return runLater((id) => next(updateAction(action, id)), action.queryKey);
    }
    else if (action.type === setConnectionId.type && action.payload) {
        const impacted = action.payload.requests?.map((r) => ({ connectionId: action.payload.id, requestId: r }));
        if (impacted?.length) {
            for (const request of pending.filter((p) => !p.done).map((p) => ({ id: getConnectionId(p.queryKey, impacted), p }))) {
                queueMicrotask(() => {
                    if (request.id) {
                        request.p.delayedAction(request.id);
                        request.p.done = true;
                    }
                });
            }
        }
    }
    return next(action);
};
